import {Component} from "react";
import React from "react";
import axios from "axios";
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./../css/App.css";
toast.configure()

export default class UpdatePassword extends Component {

    constructor(props){
        super(props);
        this.state = {
            isSubmit: false,
            paramUserID: null,
            password: null,
            confirmPassword: null,
            formFieldsEmpty: null,
            userid: null,
            errors:{},
            formErrors: {
                paramUserID: "",
                password: "",
                confirmPassword: "",
                formFieldsEmpty: "",

            }
        };


    }


    //Validation for All empty Fields
    formValidation = () =>{
        const {paramUserID,password,confirmPassword} = this.state;
        let isValid = false;
        let errors = {};
        if (!paramUserID) {
            errors.paramUserID = 'Please enter valid Username';
        }if (!password) {
            errors.password = 'Please enter valid Password';
        }else{
            isValid = true;
        }
        this.setState({errors});

        return isValid;
    }



    handleChange = event => {
        let formErrors = { ...this.state.formErrors };
        const { name, value } = event.target;

        switch (name) {
            case "paramUserID":
                formErrors.paramUserID =
                    (value.length < 3) ? "Minimum 3 characters required" : "";
                break;
            case "paramUserID":
                formErrors.paramUserID =
                    (!value) ? "Please Provide a Valid Input" : "";
                break;
            case "password":
                formErrors.password =
                    value.length < 3 ? "Minimum 3 characters required" : "";
                break;
            default:
                break;
        }
        this.setState({formErrors, [event.target.name]: event.target.value });
    }

    handleSubmit = event => {
        event.preventDefault();
        const user ={
            paramUserID: this.state.userid,
            password: this.state.password,
            confirmPassword: this.state.confirmPassword
        };
        const isValid = this.formValidation();

        if(isValid) {
            axios.post(`updatePassword`, user)
                .then(res => {
                    toast.success('Password updated Successfully !!', {position: toast.POSITION.TOP_CENTER,autoClose:1000})
                    console.log(res.password);
                }).catch(error => {
                toast.error("Update Password failed", {position: toast.POSITION.TOP_CENTER,autoClose:1000})
                console.log("=== LOG_Error === Inside try catch %s with data ","Update Password",error);
            });
        }else{
            console.log("=== LOG_Error === Inside render %s with data ","Update Password",this.state);
            toast.error('Validation Failed!!', {position: toast.POSITION.TOP_CENTER,autoClose:1000})
        }

    }

    render() {
        console.log("=== LOG_1 === Inside render %s with data ","Update Password",this.props.data.data);
        const { formErrors } = this.state;
        const {paramUserID,password,errors} = this.state;
        if (typeof this.props.data.data !== 'undefined'){
             this.state.userid=this.props.data.data.clickedUserId
        }else{
            this.state.userid ="Admin"
        }
        return <div className="tab-pane" id="tb_changepassword" role="tabpanel">
            <h5 className="tbsub-title mt-3 mb-3">Change the Password:  {this.state.userid}</h5>
        <form onSubmit={this.handleSubmit}>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="control-label">New Password</label>
                        <input type="password" name="password" className={formErrors.password.length > 0 ? "form-control error" : "form-control"}  autoComplete="off" onChange={this.handleChange}
                               placeholder="Enter Password"/>
                        {formErrors.password.length > 0 && (
                            <span className="errorMessage">{formErrors.password}</span>
                        )}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="control-label">Confirm New Password</label>
                        <input type="password" name="confirmPassword" className={formErrors.confirmPassword.length > 0 ? "form-control error" : "form-control"}  autoComplete="off" onChange={this.handleChange}
                               placeholder="Re-Enter Password"/>
                        {formErrors.confirmPassword.length > 0 && (
                            <span className="errorMessage">{formErrors.confirmPassword}</span>
                        )}
                    </div>
                </div>
            </div>
            <div className="row mt-5 justify-content-md-center">
                <div className="col-md-4">
                    <button type="submit"
                            className="btn btn-block btn-primary w-md">Save
                    </button>
                </div>
            </div>
         </form>
        </div>
    }
}